export default __webpack_public_path__ + "static/media/23_gallery.d2290db1.jpg";